<template>
  <transition name="fade" mode="out-in">
    <div class="gift-page-container">
      <nav-component :isMobile="isMobile"></nav-component>
      <div class="gift-codes-header">
        <div class="centering">
          <div class="header-copy">
            <img src="@/assets/img/gift-codes-blue.svg" alt />
            <h1>The Virtual Gift Code that Delivers Instant Rewards</h1>
            <p>Redeemable in 85+ countries for merchandise, virtual rewards, retail gift cards, hotels, travel, experiences, event tickets, and mobile top-up! Purchase Gift Codes in the currency of your choice through our built-in converter and send them around the world with secure, encrypted code delivery.</p>
          </div>
          <img class="header-img" src="@/assets/img/gift-codes-header.png" alt />
        </div>
      </div>
      <div class="solution-intro">
        <p>Say farewell to the complexity of reward management with the speed and simplicity of Gift Codes. The best reward to boost loyalty, recognize performance, and engage employees.</p>
      </div>
      <div class="innovative-body">
        <h2>How You Can Use Gift Codes</h2>
        <div class="innovative-icons-container">
          <div class="row">
            <div class="innovative-icon with-transition-delay simple-fade">
              <div class="icon-holder one">
                <img src="@/assets/img/gift1.png" alt />
              </div>
              <p><strong class="charcoal">Global&nbsp;Rewards</strong></p>
              <p
                class="charcoal small"
              >Customize and build your perfect rewards solution with variable denominations, from 10 cents, all the way to 2500 dollars.</p>
            </div>
            <div class="innovative-icon simple-fade">
              <div class="icon-holder two">
                <img src="@/assets/img/gift2.png" alt />
              </div>
              <p><strong class="charcoal">Badges</strong></p>
              <p
                class="charcoal small"
              >Power up by linking your Badges, social media, and performance metrics to specific Gift Codes values.</p>
            </div>
            <div class="innovative-icon simple-fade">
              <div class="icon-holder three">
                <img src="@/assets/img/gift3.png" alt />
              </div>
              <p><strong class="charcoal">Monetize Apps</strong></p>
              <p
                class="charcoal small"
              >Solution providers can automatically monetize your apps using our quick connect API’s.</p>
            </div>
          </div>
          <div class="row">
            <div class="innovative-icon with-transition-delay simple-fade">
              <div class="icon-holder four">
                <img src="@/assets/img/innovation8.png" alt />
              </div>
              <p><strong class="charcoal">Instant Gifting</strong></p>
              <p
                class="charcoal small"
              >Say thank you with Gift Codes and instantly connect your recipients to millions of reward choices.</p>
            </div>
            <div class="innovative-icon simple-fade">
              <div class="icon-holder five">
                <img src="@/assets/img/innovation6.png" alt />
              </div>
              <p><strong class="charcoal">Research</strong></p>
              <p
                class="charcoal small"
              >Increase panellist participation by offering instant recognition and greater reward choice.</p>
            </div>
            <div class="innovative-icon simple-fade">
              <div class="icon-holder six">
                <img src="@/assets/img/gift6.png" alt />
              </div>
              <p><strong class="charcoal">Instant Loyalty</strong></p>
              <p
                class="charcoal small"
              >Instantly reward your members by connecting them to the world’s largest reward gallery.</p>
            </div>
          </div>
        </div>
      </div>
      <div class="email-to-shop">
        <h2>Go from email to shopping in seconds!</h2>
        <p class="charcoal push-down-lil">Simple 2-step Redemption Process</p>
        <div class="full-width-img-top">
          <div class="inner">
            <div class="left copy">
              <h3>
                <span class="blue-dot">1</span> Activate
              </h3>
              <p class="charcoal">Redeem your Gift Codes.</p>
            </div>
            <div class="right simple-fade">
              <img src="@/assets/img/giftcodes-screens-1-new.png" alt />
            </div>
          </div>
        </div>
        <div class="full-width-img-bottom">
          <div class="inner">
            <div class="right simple-fade">
              <img src="@/assets/img/giftcodes-screens-2-new.png" alt />
            </div>
            <div class="left copy">
              <h3>
                <span class="blue-dot">2</span> Shop
              </h3>
              <p class="charcoal">Shop Instantly.</p>
            </div>
          </div>
        </div>
      </div>
      <div class="global-gift-codes">
        <h3 class="charcoal">Purchase Global Gift Codes</h3>
        <p
          class="charcoal"
        >Gift Codes are redeemable in 85 countries, simply pick the Gift Code that matches your recipients interests</p>
        <div class="global-cards-container">
          <div class="row">
            <div class="card">
              <img src="@/assets/img/g-everything.jpg" class="card-img" alt />
              <h4>The Everything Code</h4>
              <p class="charcoal">Redeemable towards every reward type.</p>
            </div>
            <div class="card">
              <img src="@/assets/img/g-digital.jpg" class="card-img" alt />
              <h4>Digital Gift Codes</h4>
              <p class="charcoal">Includes mobile top-up, gift cards and travel.</p>
            </div>
            <div class="card">
              <img src="@/assets/img/g-mobile.jpg" class="card-img" alt />
              <h4>Gift Codes for Mobile</h4>
              <p
                class="charcoal"
              >Choose your carrier and receive an instant credit with just one click.</p>
            </div>
          </div>
          <div class="row">
            <div class="card">
              <img src="@/assets/img/g-gift.jpg" class="card-img" alt />
              <h4>Global Retail Gift Cards</h4>
              <p class="charcoal">Thousands of the world’s best retail gift cards to choose from.</p>
            </div>
            <div class="card">
              <img src="@/assets/img/g-travel.jpg" class="card-img" alt />
              <h4>Gift Codes Travel</h4>
              <p class="charcoal">Over 400,000 hotels plus cars, cruises, airlines and more...</p>
            </div>
            <div class="card">
              <img src="@/assets/img/g-savings.jpg" class="card-img" alt />
              <h4>Gift Codes Savings</h4>
              <p
                class="charcoal"
              >Save at hundreds of thousands of retail stores throughout North America.</p>
            </div>
          </div>
        </div>
      </div>
      <div class="features-benefits">
        <h2>Features and Benefits</h2>
        <div class="features-list">
          <div class="left">
            <p class="checkmark">The world’s most comprehensive global shopping mall.</p>
            <p class="checkmark">Locally sourced and delivered rewards.</p>
            <p class="checkmark">Secure, encrypted API code delivery system.</p>
            <p class="checkmark">Connect directly to our API to order Gift Codes in real time.</p>
            <p class="checkmark">Secure mobile wallet with credit card top-up.</p>
          </div>
          <div class="right">
            <p class="checkmark">Buy single or bulk Gift Codes in any currency.</p>
            <p
              class="checkmark"
            >Users can bank points or instantly redeem by topping-up with Paypal.</p>
            <p class="checkmark">Fast and easy reward redemption for your members.</p>
            <p class="checkmark">Instantly shop in 85 countries.</p>
          </div>
        </div>
      </div>
      <footer-component></footer-component>
    </div>
  </transition>
</template>

<script>
export default {
  data: function () {
    return {
      name: 'gift-codes',
      isMobile: window.innerWidth < 992
    }
  },
  methods: {
    handleResize() {
      this.isMobile = window.innerWidth < 992;
    }
  },
  mounted () {
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>

<style>
/*HEADER/HERO*/
.gift-codes-header {
  background-color: #C7DFFF;
  width: 100%;
  padding: 100px 0 30px;
}

.gift-codes-header .centering {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  width: 80%;
  max-width: 1200px;
  margin: 0 auto;
}
.gift-codes-header .header-copy {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-top: 0;
}
.gift-codes-header .header-copy img { width: 130px; }
.gift-codes-header .header-copy h1 {
  margin: 10px 0;
  color: #343333;
  font-size: 48px;
  font-weight: 700;
  line-height: 52px;
  margin: 16px 0;
}
.gift-codes-header .header-copy p {
  width: 90%;
  color: #343333;
  font-size: 18px;
  font-weight: 300;
  line-height: 24px;
  margin: 0;
}
.gift-codes-header .header-img {
  width: 40%;
  height: auto;
  align-self: center;
}

@-moz-document url-prefix() {
  .gift-page-container .gift-codes-header .header-img {
    width: 108%;
  }
}

/*MAIN PAGE BODY SECTION*/
.gift-page-container .solution-intro {
  width: 100% !important;
  margin: 0 auto;
  text-align: center;
  padding: 50px 80px;
  box-sizing: border-box;
  background: #006EFF;
}
.gift-page-container .solution-intro p {
  color: #FFF;
  text-align: center;
  font-size: 20px;
  font-weight: 700;
  line-height: 28px;
  margin: 0 auto;
  width: 80%;
  max-width: 1200px;
  margin: 0 auto;
}

.innovative-body {
  background-color: #eeeeee;
  padding: 60px 0 10px;
  text-align: center;
}

.innovative-body h2 {
  color: #343333;
  text-align: center;
  font-size: 32px;
  font-weight: 700;
  line-height: 52px;
}

.innovative-icons-container {
  margin: 0 auto 60px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 80%;
  max-width: 1200px;
}
.innovative-icons-container .row {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: flex-start;
  width: 70%;
  margin-bottom: 30px;
}
.innovative-icons-container .row p {
  margin: 0 0 10px 0;
  color: #343333;
  text-align: center;
  font-size: 14px;
  font-weight: 700;
  line-height: 21px;
}
.innovative-icons-container p strong {
  font-weight: 700;
  color: #000;
}
.innovative-icons-container .row p.small {
  margin-bottom: 0;
  color: #000;
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
}

.innovative-icon {
  max-width: 200px;
}

.icon-holder {
  width: 20px;
  height: 20px;
  padding: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  margin: 0 auto 15px;
}
.icon-holder img {
  width: 60px !important;
  position: absolute;
}

.icon-holder.one{
  background-color: #00A4FF;
}
.icon-holder.two{
  background-color: #C7116B;
}
.icon-holder.three{
  background-color: #00A561;
}
.icon-holder.four{
  background-color: #F26533;
}
.icon-holder.five{
  background-color: #A817A3;
}
.icon-holder.six{
  background-color: #0079BC;
}

.container {
  width: 90%;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.container h2 {
  margin-bottom: 20px;
}

.container p {
  width: 70%;
  margin-bottom: 40px;
}

.salesforce-intg {
  background-color: #edf5ff;
}

.salesforce-intg .container {
  width: 80%;
  max-width: 1200px;
  padding: 80px 0;
}

.salesforce-logo-container img {
  width: 275px;
}

.email-to-shop {
  text-align: center;
  padding: 60px 0;
}
.email-to-shop h2 {
  margin-bottom: 30px;
  color: #343333;
  font-size: 32px;
  font-weight: 700;
  line-height: 52px;
}
.email-to-shop p.push-down-lil {
  margin-bottom: 50px;
}

.full-width-img-top {
  background-image: url(../assets/img/blue-stripe-top.png);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  margin-bottom: 60px;
}

.full-width-img-top h3,
.full-width-img-bottom h3 {
  margin: 0;
  font-weight: 300;
  color: #343333;
  font-size: 46px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.full-width-img-top .inner,
.full-width-img-bottom .inner {
  position: relative;
  top: -15px;
}

.full-width-img-bottom {
  background-image: url(../assets/img/blue-stripe-bottom.png);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
}

.full-width-img-top .inner,
.full-width-img-bottom .inner {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 90%;
  margin: 0 auto;
}

.full-width-img-top .left,
.full-width-img-top .right,
.full-width-img-bottom .left,
.full-width-img-bottom .right {
  width: 50%;
}

.full-width-img-top .left,
.full-width-img-bottom .right {
  position: relative;
  top: -5px;
}

.full-width-img-top .right img,
.full-width-img-bottom .right img {
  width: 90%;
  max-width: 850px;
}

span.blue-dot {
  background-color: #006eff;
  border-radius: 50%;
  padding: 20px;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 700;
  /*margin-bottom: 10px;*/
}

.global-gift-codes {
  text-align: center;
  padding: 60px 0;
  width: 80%;
  max-width: 1200px;
  margin: 0 auto;
}
.global-gift-codes h3 {
  margin-bottom: 0;
  color: #343333;
  text-align: center;
  font-size: 32px;
  font-weight: 700;
  line-height: 52px;
}

.global-gift-codes p {
  color: #343333;
  text-align: center;
  font-size: 18px;
  font-weight: 300;
  line-height: 24px;
}

.global-cards-container .row {
  justify-content: space-between;
  margin-top: 70px;
  align-items: flex-start;
}

.card {
  width: 30%;
}
.card h4 {
  color: #343333;
  text-align: center;
  font-size: 18px;
  font-weight: 700;
  line-height: 21px;
  margin: 0;
}

.card-img {
  width: 100%;
  margin-bottom: 20px;
  /*box-shadow: -7px -4px 39px -5px rgba(0,0,0,0.39);*/
}

.features-benefits {
  background-color: #006eff;
  padding: 60px 0;
  text-align: center;
}
.features-benefits h2 {
  color: #FFF;
  text-align: center;
  font-size: 32px;
  font-weight: 700;
  line-height: 52px;
  margin-bottom: 10px;
}
.features-list {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  text-align: left;
  width: 80%;
  max-width: 1200px;
  margin: 0 auto;
}

p.checkmark {
  background: transparent url(../assets/img/checkmark.png) no-repeat;
  background-size: 20px;
  background-position: left center;
  padding-left: 40px;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
}

@media (max-width: 992px) {
  .gift-codes-header img.header-img {
    display: none;
  }
  .gift-codes-header .header-copy {
    padding-top: 0;
  }
  .gift-codes-header .header-copy h1 {
    font-size: 42px;
  }

  .gift-page-container .solution-intro {
    /* width: 90% !important; */
    padding: 50px 0;
  }

  .gift-page-container .innovative-icons-container .row {
    width: 100%;
  }
  .gift-page-container .innovative-icon {
    width: 150px;
    max-width: 150px;
  }
  .gift-page-container .innovative-icon .icon-holder {
    width: 0px;
    height: 0px;
    padding: 40px;
  }

  .gift-page-container .innovative-icon .icon-holder img { width: 40px !important; }

  .gift-page-container .full-width-img-top .copy h2 {
    font-size: 32px;
  }

  .gift-page-container .full-width-img-top .inner .left.copy,
  .gift-page-container .full-width-img-bottom .inner .left.copy {
    position: relative;
    top: 23px;
  }

  .gift-page-container .salesforce-intg .container {
    flex-direction: column;
    width: 90%;
    margin: 0 auto;
  }
  .gift-page-container .salesforce-intg .container .copy {
    text-align: center;
  }
  .gift-page-container .salesforce-intg .container .copy p {
    width: 90%;
    margin: 0 auto 40px;
  }

  .gift-page-container .salesforce-logo-container {
    margin: 40px 0 0;
  }

  .global-cards-container .row {
    flex-direction: column;
  }
  .global-cards-container .row:last-of-type {
    margin-top: 0;
  }
  .global-cards-container .row .card {
    width: 100%;
    margin-bottom: 40px;
  }

  .features-list {
    flex-direction: column;
  }

  span.blue-dot {
    padding: 10px;
    width: 30px;
    height: 30px;
  }

  .full-width-img-top h3,
  .full-width-img-bottom h3 {
    font-size: 30px;
  }

  .full-width-img-top .left.copy p,
  .full-width-img-bottom .left.copy p {
    margin: 0;
  }
}
</style>
